// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2025 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

import BaseModel from '@glittr/frontend-core/src/plugins/servicelayer/serviceTypes/baseModel';
import CockpitNotificationDifferenceResourceViewModel from '../../../../viewModel/resource/CockpitNotificationDifferenceResourceViewModel';
import CockpitNotificationDifferenceResourceDTO from '../../dto/resource/CockpitNotificationDifferenceResourceDTO';

export default abstract class CockpitNotificationDifferenceResourceModel extends BaseModel<CockpitNotificationDifferenceResourceDTO> {
  /**
  * @type {int32}
  */
  get count() { return this.dto.count; }
  set count(value) { this.dto.count = value; }
  /**
  * @type {date-time}
  */
  get lastCreation() { return this.dto.lastCreation; }
  set lastCreation(value) { this.dto.lastCreation = value; }

  protected transformFromQuery(queries: Record<string, string>): void {
    const qs = {} as Record<string, string>;
    Object.keys(queries).forEach((key) => { qs[key.toLowerCase()] = queries[key]; });
    let value: any;
    value = Number.parseFloat(qs.count);
    value = Number.isNaN(value) ? undefined : value;
    this.dto.count = value;
    this.dto.lastCreation = qs.lastcreation;
  }
}
